export const DATA = {
  STRUGGLE_WITH_WEIGHT_GAIN: "I struggle with weight and muscle gain",
  EASY_WEIGHT_GAIN_AND_LOSS: "I gain and lose weight quickly",
  STRUGGLE_WITH_WEIGHT_LOSS: "I struggle with weight loss",
};
